import { render, staticRenderFns } from "./IsLoading.vue?vue&type=template&id=12d7b1bf&scoped=true&"
import script from "./IsLoading.vue?vue&type=script&lang=ts&"
export * from "./IsLoading.vue?vue&type=script&lang=ts&"
import style0 from "./IsLoading.vue?vue&type=style&index=0&id=12d7b1bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d7b1bf",
  null
  
)

export default component.exports